export default from './UpdatePasswordForm';



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentSettingsPage/components/UpdatePasswordForm/index.js